module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "DatabaseSearch-form u-form u--form--light",
    attrs: {
      "action": "/search",
      "method": "get"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('primary-facets'), _vm._v(" "), (_vm.params.recordType === 'District') ? _c('district-facets') : _vm._e(), _vm._v(" "), (_vm.params.recordType === 'Election') ? _c('election-facets') : _vm._e(), _vm._v(" "), (_vm.params.recordType === 'Person') ? _c('person-facets') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3423495f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/database-search/search-form.vue
// module id = 327
// module chunks = 0